export const LOGO_URL = "https://customer-assets-lxgj4vgw.emergentagent.net/job_printer-info/artifacts/3gluv5wx_Allaboutprinterslogo.jpg";

export const CONTACT = {
    phone: "+1 877 949 6786",
    phoneHref: "tel:+18779496786",
    phoneDisplay: "(877) 949-6786",
    email: "info@allaboutprinters.blog",
    emailHref: "mailto:info@allaboutprinters.blog",
    hours: "Mon–Fri · 9am–6pm ET",
};

export const TYPE_LABELS = {
    "inkjet": "Inkjet",
    "laser": "Laser",
    "all-in-one": "All-in-One",
    "3d": "3D Printer",
};
